import DefaultAvatar from "./defaultAvatar.png";
import LoginPlaceholder from "./login-placeholder.png";
import Logo from "./Logo.png";
const Images = {
  DefaultAvatar,
  LoginPlaceholder,
  Logo,
};

export { Images };
